{
  "AGENT_MGMT": {
    "HEADER": "Agenți",
    "HEADER_BTN_TXT": "Adaugă agent",
    "LOADING": "Se preia lista de agenți",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrator",
      "AGENT": "Agent"
    },
    "TABS": {
      "ACTIVE": "Active",
      "DEACTIVATED": "Dezactivate"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Deconectează telefonul",
      "API": {
        "SUCCESS_MESSAGE": "Telefonul agentului a fost deconectat cu succes",
        "ERROR_MESSAGE": "Nu s-a putut deconecta telefonul agentului, vă rugăm să încercați din nou mai târziu"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Reactivează",
      "API": {
        "SUCCESS_MESSAGE": "Agent reactivat cu succes",
        "ERROR_MESSAGE": "Nu s-a putut reactiva agentul, vă rugăm să încercați din nou mai târziu"
      },
      "CONFIRM": {
        "TITLE": "Confirmă reactivarea",
        "MESSAGE": "Sigur doriți să reactivați ",
        "YES": "Da, reactivează ",
        "NO": "Nu, anulează "
      }
    },
    "LIST": {
      "404": "Nu există agenți asociați acestui cont",
      "TITLE": "Gestionează agenții din echipa ta",
      "DESC": "Puteți adăuga/elimina agenții în/din echipa dvs.",
      "NAME": "Nume",
      "EMAIL": "E-MAIL",
      "STATUS": "Status",
      "ACTIONS": "Actiuni",
      "VERIFIED": "Verificat",
      "VERIFICATION_PENDING": "Verificare în așteptare",
      "API_ALLOWED": "API permis",
      "DEACTIVATED_ON": "Dezactivat la",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Adaugă un agent echipei tale",
      "DESC": "Puteți adăuga persoane care vor putea să se ocupe de suportul pentru inbox-urile dvs.",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "FORM": {
        "NAME": {
          "LABEL": "Nume Agent",
          "PLACEHOLDER": "Vă rugăm să introduceţi un nume de agent"
        },
        "AGENT_TYPE": {
          "LABEL": "Tip Agent",
          "PLACEHOLDER": "Te rog selecteaza un tip",
          "ERROR": "Tipul de agent este obligatoriu"
        },
        "EMAIL": {
          "LABEL": "Adresa Email",
          "PLACEHOLDER": "Vă rugăm să introduceți o adresă de e-mail a agentului"
        },
        "SUBMIT": "Adaugă Agent"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent adăugat cu succes",
        "EXIST_MESSAGE": "Agent e-mail deja folosit, te rugăm să încerci o altă adresă de e-mail",
        "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Şterge",
      "API": {
        "SUCCESS_MESSAGE": "Agent sters cu succes",
        "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
      },
      "CONFIRM": {
        "TITLE": "Confirmă ștergerea",
        "MESSAGE": "Sigur doriți să ștergeți ",
        "DESCRIPTION": "Agentul va fi deconectat imediat, eliminat din toate echipele și inbox-urile și nu va mai putea accesa acest cont.",
        "YES": "Da, șterge ",
        "NO": "Nu, păstreaza "
      }
    },
    "EDIT": {
      "TITLE": "Editează agent",
      "FORM": {
        "NAME": {
          "LABEL": "Nume Agent",
          "PLACEHOLDER": "Vă rugăm să introduceţi un nume de agent"
        },
        "AGENT_TYPE": {
          "LABEL": "Tip Agent",
          "PLACEHOLDER": "Vă rugăm să selectaţi un tip",
          "ERROR": "Tipul de agent este obligatoriu"
        },
        "EMAIL": {
          "LABEL": "Adresa Email",
          "PLACEHOLDER": "Vă rugăm să introduceți o adresă de e-mail a agentului"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Disponibilitate",
          "PLACEHOLDER": "Vă rugăm să selectați o stare de disponibilitate",
          "ERROR": "Disponibilitatea este necesară"
        },
        "API_ACCESS": {
          "LABEL": "Permite accesul la API",
          "HELP": "Accesul la API este dezactivat implicit. Activarea lui permite ca cheia API personală a acestui agent să fie folosită în toate conturile din care face parte. Conectarea la tabloul de bord nu este afectată."
        },
        "SUBMIT": "Editează agent"
      },
      "BUTTON_TEXT": "Editare",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "API": {
        "SUCCESS_MESSAGE": "Agent actualizat cu succes",
        "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Resetează Parola",
        "ADMIN_SUCCESS_MESSAGE": "Un e-mail cu instrucțiunile de resetare a parolei a fost trimis agentului",
        "SUCCESS_MESSAGE": "Parola resetata cu succes",
        "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Niciun rezultat găsit."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Nimic",
      "TITLE": {
        "AGENT": "Selectați agentul",
        "TEAM": "Selectați echipa"
      },
      "LIST": {
        "NONE": "Nimic"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Niciun agent găsit",
          "TEAM": "Nu au fost găsite echipe"
        },
        "PLACEHOLDER": {
          "AGENT": "Agenți de căutare",
          "TEAM": "Echipele de căutare",
          "INPUT": "Căutare agenți"
        }
      }
    }
  }
}
